var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{attrs:{"id":_vm.table_id,"options":_vm.options},on:{"action":function($event){}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }